var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label label-pill label-inline ml-3",class:_vm.computedProjectStatus.state,staticStyle:{"position":"relative","top":"-1px"}},[_vm._v(" "+_vm._s(_vm.computedProjectStatus.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }